module.exports = {
	"de": {
		"titel": "Die Halle der Runen-Karten"
	},
	"en": {
		"titel": "Buy"
	}
};


//////////////////
// WEBPACK FOOTER
// ./lib/runeset-shop-euro-view/locales.json
// module id = 66
// module chunks = 0